<template>
  <div>
    <div
      class="vs-component vs-con-input-label w-full vs-input mb-1 vs-input-primary">
      <vs-row class="vx-row">
        <vs-col vs-w="4">
          <VueCtkDateTimePicker
            no-button-now
            label="Select Start Date"
            format="YYYY-MM-DD HH:mm"
            :min-date="minStart"
            :max-date="maxStart"
            v-model="dateStart" />
        </vs-col>
        <vs-col vs-w="4">
          <VueCtkDateTimePicker
            no-button-now
            label="Select End Date"
            format="YYYY-MM-DD HH:mm"
            :min-date="dateStart"
            :max-date="maxEnd"
            v-model="dateEnd" />
        </vs-col>
        <vs-col vs-w="2">
          <v-select
            placeholder="- Select Event Type -"
            @input="(x) => (event_type = x.value)"
            :clearable="false"
            :value="getSelectValue(event_type, event_list)"
            :reduce="(text) => text.value"
            label="text"
            :options="event_list" />
        </vs-col>
      </vs-row>
    </div>
    <div
      class="overviews-cont vs-con-loading__container"
      style="max-height: 100%">
      <div style="max-height: 747px; overflow-y: scroll; overflow-x: hidden">
        <div
          v-if="showedList.length == 0"
          class="flex items-center justify-center"
          style="height: 600px">
          no alert detected
        </div>
        <div
          v-else
          v-for="(tr, indextr) in showedList"
          :key="indextr"
          class="shadow overviewbg"
          style="padding: 10px 0; margin: 10px 0; border-radius: 8px">
          <vs-row vs-w="12">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-xs="1"
              vs-lg="1"
              vs-md="1"
              vs-sm="1"
              style="position: relative">
              <div
                style="
                  background: #42aeef;
                  border-radius: 50%;
                  width: 50px;
                  height: 50px;
                  top: 50%;
                  transform: translateY(-50%);
                  position: absolute;
                ">
                <!-- Icon placeholder or loader -->
              </div>
            </vs-col>
            <vs-col vs-xs="11" vs-lg="11" vs-md="11" vs-sm="11">
              <h5
                style="
                  color: #000000;
                  border-radius: 0 10px;
                  padding: 3px 22px;
                  margin-right: -16px;
                  margin-top: -10px;
                  background: #f2cd30;
                ">
                {{ tr.event_type == 'SAMPLING' ? '&#8205;' : tr.event_type }}
              </h5>
              <vs-row vs-w="12">
                <!-- <vs-col vs-xs="6" vs-lg="6" vs-md="6" vs-sm="6">
                  <div style="display: flex; position: relative">
                    <div class="float-left pl-1">
                      <p v-if="tr.address">
                        {{ tr.address }}
                      </p>
                      <p v-else class="loader_1"></p>
                    </div>
                  </div>
                </vs-col> -->
                <!-- <vs-col vs-xs="1" vs-lg="1" vs-md="1" vs-sm="1">
                  {{ tr.speed }} km/h
                </vs-col> -->
                <vs-col
                  vs-xs="10"
                  vs-lg="10"
                  vs-md="10"
                  vs-sm="10"
                  style="padding: 0">
                  <div class="product-name font-medium" style="display: flex">
                    <div class="float-left pl-1">
                      <!-- {{ tr.normal_time ? tr.normal_time : tr.tm }} WIB -->
                      {{ tr.tm }} WIB
                    </div>
                  </div>
                </vs-col>
                <vs-col
                  vs-xs="2"
                  vs-lg="2"
                  vs-md="2"
                  vs-sm="2"
                  style="padding: 0">
                  <div class="product-name font-medium" style="display: flex">
                    <!-- <vs-button @click="getPlaybackAlarm(tr.id)">
                      <i class="fa fa-eye"></i>
                    </vs-button> -->
                    <vs-button
                      v-if="camType === 'STONKAM'"
                      radius
                      class="mt-2"
                      color="danger"
                      type="border"
                      icon="videocam"
                      @click="getPlaybackAlarm(tr)"></vs-button>
                    <div v-else>
                      <vs-button
                        v-if="tr.fileType == '02'"
                        radius
                        class="mt-2"
                        color="danger"
                        type="border"
                        icon="videocam"
                        @click="getPlaybackAlarm(tr)"></vs-button>
                      <vs-button
                        v-else
                        radius
                        class="mt-2"
                        color="danger"
                        type="border"
                        icon="image"
                        @click="getPlaybackAlarm(tr)"></vs-button>
                    </div>
                  </div>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
        </div>
        <vs-popup class="holamundo" title="Playback" :active.sync="popupActivo">
          <div class="flex flex-row">
            <!-- list of video channel -->
            <div
              class="flex flex-row flex-wrap"
              v-if="data.length > 0"
              v-for="(obj, index) in data">
              <vs-button :key="index" @click="download_data(obj)" class="m-1">
                Download Video {{ index + 1 }}
              </vs-button>
            </div>
            <div v-if="data.length == 0">
              <p>No video available</p>
            </div>
          </div>
          <!-- <div id="video-container" style="position: relative">
            <video
              :id="`live-video`"
              class="w-full"
              style="position: relative; z-index: 99"
              controls></video>
            <div
              v-if="status === 'loading'"
              class="absolute"
              style="top: 50%; left: 50%; transform: translate(-50%, -50%)">
              Loading...
            </div>
            <div
              v-else
              class="absolute"
              style="
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 100;
              ">
              Playback not found
            </div>
          </div> -->
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import FlvJs from 'flv.js'
import moment from 'moment'
import * as REPO from '../../repository/index'

export default {
  name: 'MonitoringAlertCamera',
  props: {
    license_plate: String,
    dashcam: String,
  },
  data() {
    return {
      overview: [],
      event_type: '',
      event_list: [],
      deviceId: '',
      camType: 'STONKAM',
      popupActivo: false,
      flvPlayer: null,
      status: 'loading',
      data: [],
      activeVideoChannel: 0,

      dateStart: moment().startOf('day').format('YYYY-MM-DD HH:mm'),
      dateEnd: moment().endOf('day').format('YYYY-MM-DD HH:mm'),
      minStart: moment()
        .subtract(27, 'days')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm'),
      maxStart: moment().endOf('day').format('YYYY-MM-DD HH:mm'),
      maxEnd: moment().endOf('day').format('YYYY-MM-DD HH:mm'),
    }
  },
  computed: {
    getSelectValue(value, list) {
      return list.find((x) => x.value === value)
    },
  },
  created() {
    const dc = JSON.parse(this.dashcam)
    //
    this.camType = dc.type
    this.deviceId = dc.device_id

    if (this.camType === 'STONKAM') {
      this.event_list = [
        {
          text: 'All',
          value: 128,
        },
        {
          text: 'Distraction',
          value: 33,
        },
        {
          text: 'No Seatbelt',
          value: 62,
        },
        {
          text: 'Fatigue',
          value: 32,
        },
        {
          text: 'Calling',
          value: 36,
        },
        {
          text: 'Smoking',
          value: 35,
        },
        {
          text: 'Yawn',
          value: 47,
        },
      ]

      this.event_type = 128
    } else {
      this.event_list = [
        {
          text: 'All',
          value:
            'fatigueAlarm,handheldPhoneCall,longTimeWithoutLookingAhead,seatbelt,smoking,fatigueWarn',
        },
        {
          text: 'Distraction',
          value: 'longTimeWithoutLookingAhead',
        },
        {
          text: 'No Seatbelt',
          value: 'seatbelt',
        },
        {
          text: 'Fatigue Alarm',
          value: 'fatigueAlarm',
        },
        {
          text: 'Calling',
          value: 'handheldPhoneCall',
        },
        {
          text: 'Smoking',
          value: 'smoking',
        },
        {
          text: 'Fatigue Warning',
          value: 'fatigueWarn',
        },
      ]

      this.event_type =
        'fatigueAlarm,handheldPhoneCall,longTimeWithoutLookingAhead,seatbelt,smoking,fatigueWarn'
    }
  },
  computed: {
    showedList() {
      const self = this
      if (this.camType == 'STONKAM') {
        const data = this.overview
          .map((x) => {
            const alarmType = self.event_list.find((y) => y.value === x.tp)

            return {
              ...x,
              event_type: alarmType ? alarmType.text : 'Unknown',
            }
          })
          .filter((x) => x.event_type !== 'Unknown')
        return data
      } else {
        const data = this.overview
          .map((x) => {
            const alarmType = self.event_list.find(
              (y) => y.value === x.alarmType
            )

            return {
              ...x,
              event_type: alarmType ? alarmType.text : 'Unknown',

              tm: moment(x.alarmTime).add(7, 'hours').format('YYYY-MM-DD HH:mm:ss'),
            }
          })
          .filter((x) => x.event_type !== 'Unknown')

        return data
      }
    },
  },
  watch: {
    event_type(val) {
      this.getData()
    },
    activeVideoChannel(val) {
      this.destroyVideo()
      this.startVideo(this.data[val].FileName)
    },
    dateStart(val) {
      this.getData()
    },
    dateEnd(val) {
      this.getData()
    },
  },
  mounted() {
    //
    this.getData()
    // distraction, seatbelt, fatigue, call, smoking, yawn
  },
  methods: {
    download_data(obj) {
      //
      const url = `https://api-camera-file.treffix.id/DownloadRecordFile.php?User=ttp-treffix&SessionId=1071&FileId=${obj.FileId}`

      window.open(url, '_blank')
    },
    getPlaybackAlarm(tr) {
      if (this.camType === 'STONKAM') {
        this.popupActivo = true

        const body = {
          UserName: 'ttp-treffix',
          DeviceId: this.deviceId,
          AlarmId: tr.id,
          SessionId: 1071,
        }

        REPO.testGetRecordByAlarmId(this.deviceId, body)
          .then((res) => {
            this.data = res.data.RecordFileList
            //
            // if (this.data.length < 2) {
            //   this.status = 'error'
            // } else {
            //   // this.startVideo(this.data[0].FileName)
            //   // this.activeVideoChannel = 0
            // }
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        const fileName = `test.mp4`
        this.download(tr.fileUrl, fileName)
      }
    },
    download(dataurl, filename) {
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = dataurl
      link.download = filename
      link.click()
    },
    startVideo(filename) {
      const videoElement = document.getElementById(`live-video`)
      const tmpUrl = 'http://Playback-camera.treffix.id'
      const url = `${tmpUrl}/PlaybackDevice/${filename}?DeviceId=${this.deviceId}&TimeOffset=0&UserName=ttp-treffix&SessionId=1071`
      //

      this.flvPlayer = FlvJs.createPlayer(
        {
          type: 'flv',
          isLive: true,
          hasAudio: false,
          hasVideo: true,
          // url: `http://35.198.202.131:8082/OpenDeviceStream/100?DeviceId=${this.deviceId}&ChannelId=${obj.value}&RealTime=1&SessionId=1071`,
          url: url,
        },
        {
          enableStashBuffer: false,
        }
      )
      this.flvPlayer.attachMediaElement(videoElement)
      this.flvPlayer.on(FlvJs.Events.LOADING_COMPLETE, () => {
        // isOnline = true
        // this.loadingStop('#video-container')
      })
      this.flvPlayer.on(FlvJs.Events.ERROR, (errType, errDetail) => {
        console.error('FLV Error:', errType, errDetail)
        // status = 'error'
        // isOnline = false
        // this.reloadVideo()
      })
      this.flvPlayer.load()
      this.flvPlayer.play()
    },
    destroyVideo() {
      if (this.status !== 'error') {
        this.flvPlayer.pause()
        this.flvPlayer.unload()
        this.flvPlayer.detachMediaElement()
        this.flvPlayer.destroy()
        this.flvPlayer = null
      }
      this.status = 'loading'
    },
    async getData() {
      const self = this

      if (this.camType === 'STONKAM') {
        const sessionId = 1071
        const beginTime = moment(this.dateStart).format('YYYY~MM~DD~HH~mm~ss')
        const endTime = moment(this.dateEnd).format('YYYY~MM~DD~HH~mm~ss')

        const body = {
          DeviceId: self.deviceId,
          SessionId: sessionId,
          BeginTime: beginTime,
          EndTime: endTime,
          AlarmType: self.event_type,
        }

        try {
          const res = await REPO.getMonitoringAlertCamera(body)
          const resData = res.data.AlarmHisotryData

          self.overview = resData
            .map((x) => {
              const alarmType = self.event_list.find((y) => y.value === x.tp)
              return {
                ...x,
                normal_time: moment(x.tm)
                  .add(7, 'hours')
                  .format('YYYY-MM-DD HH:mm:ss'),
                event_type: alarmType ? alarmType.text : 'Unknown',
                address: null, // Initialize with null to show the loader
              }
            })
            .filter((x) => x.event_type !== 'Unknown')

          // Fetch addresses after initializing the overview data
          // for (let i = 0; i < self.overview.length; i++) {
          //   if (!self.overview[i].address) {
          //     const address = await self.getAddress(
          //       self.overview[i].lat,
          //       self.overview[i].lng
          //     )
          //     self.$set(self.overview[i], 'address', address.display_name)
          //   }
          // }
        } catch (err) {}
      } else {
        const token = await REPO.getMettaXToken().then((res) => {
          //
          return res.data.data
        })

        //

        const body = {
          pageSize: 100,
          pageIndex: 1,
          // deviceIds: self.deviceId,
          deviceIds: this.deviceId,
          // alarmType: '',
          alarmType: self.event_type,
          startTime: moment(self.dateStart).format('yyyy-MM-DD HH:mm:ss'),
          endTime: moment(self.dateEnd).format('yyyy-MM-DD HH:mm:ss'),
        }

        const res = await REPO.mettaXAlertList(token, body).then((res) => {
          return res.data.data.records
        })

        self.overview = res

        //
        //   'res:',
        //   res.filter((x) => x.fileType == '02')
        // )
      }
    },

    async getAddress(latitude, longitude) {
      try {
        const body = {
          lat: latitude,
          lon: longitude,
        }
        const response = await REPO.getAddress(body)
        return response.data || { display_name: 'Unknown Address' }
      } catch (error) {
        console.error('Error fetching address:', error)
        return { display_name: 'Unknown Address' }
      }
    },
  },
}
</script>

<style lang="scss">
.datetimepicker > .flex {
  display: none !important;
}

.visible > .flex {
  display: block !important;
  left: 0;
}

.date-popup > .vs-popup > .vs-popup--content {
  overflow: visible;
}
</style>
